const SET_HEADER_TRANSPARENCY = 'SET_HEADER_TRANSPARENCY'
const RESET_LAYOUT = 'RESET_LAYOUT'

export { SET_HEADER_TRANSPARENCY, RESET_LAYOUT }
